<template>
  <el-form label-position="top" :model="form" :rules="rules" ref="form_create">
    <el-form-item
      style="margin-top: 30px; font-weight: bold"
      label="Nombre del archivo"
      prop="nameArchive"
      :rules="[{ required: true, message: 'El nombre es requerido' }]"
    >
      <el-input
        v-model="form.nameArchive"
        placeholder="Escribir el nombre del archivo"
        class="fields"
      ></el-input>
    </el-form-item>

    <el-form-item
      style="margin-top: 30px; font-weight: bold"
      label="Descripcion del archivo"
      prop="descriptionArchive"
    >
      <el-input
        v-model="form.descriptionArchive"
        placeholder="Escribir la descripcion del archivo"
        class="fields"
      ></el-input>
    </el-form-item>

    <el-form-item
      v-if="IsSupervisor"
      style="margin-top: 30px; font-weight: bold"
      label="Seleccionar empleado"
    >
      <employee-selector placeholder="Seleccionar empleado" />
    </el-form-item>

    <el-form-item
      label="Adjuntar documento"
      style="font-weight: bold"
      :rules="[{ required: true, message: 'El nombre es requerido' }]"
    >
      <el-upload
        ref="uploadFile"
        class="upload-demo"
        :drag="true"
        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
        :file-list="fileList"
        :auto-upload="false"
        :multiple="true"
        :on-success="handleUploadOnSuccess"
        :on-error="handleError"
        :on-preview="handlePreview"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          Solo archivos con un tamaño menor de 4MG
        </div>
      </el-upload>
    </el-form-item>
    <el-button @click="onCancel" size="mini">Cancel</el-button>
    <el-button
      id="btnSave"
      type="primary"
      size="mini"
      :loading="isSaving"
      :disabled="isSaving"
      @click="saveDocument"
      >Guardar</el-button
    >
  </el-form>
</template>
<script>
import direcciones from "@/helpers/directions.js";
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";

export default {
  name: "CreateDocument",
  components: {
    EmployeeSelector
  },
  props: {
    Visible: {
      type: Boolean,
      default: false
    },
    IsSupervisor: {
      type: Boolean,
      default: false,
      required: false
    },
    IsPersonal: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      isEnabled: true,
      isSaving: false,
      fileList: [],
      form: {
        nameArchive: "",
        descriptionArchive: "",
        urlArchive: "",
        companyCode: this.$store.state.user.user.CompanySelected,
        employeeId: this.$store.state.user.user.EmployeeId,
        createdBy: this.$store.state.user.user.EmployeeId
      },
      rules: {},
      categoriesValue: [],
      dataDireccion: direcciones
    };
  },

  computed: {},
  methods: {
    onCancel() {
      this.fileList = [];
      //this.$refs.uploadFile.uploadFiles = [];
      this.form = this.getEmptyForm();
      this.$emit("dialog-closed");
      this.$refs.form_create.resetFields();
    },
    saveDocument() {
      if (this.isSaving) return;

      this.isSaving = true;
      this.$refs.form_create.validate((valid) => {
        if (valid) {
          this.$refs.uploadFile.submit();
        } else {
          this.isSaving = false;
          return false;
        }
      });
    },
    handleUploadOnSuccess(response, file) {
      this.isEnabled = false;

      const uploadResponse =
        Array.isArray(file?.response) && file.response.length > 0
          ? file.response
          : Array.isArray(response)
          ? response
          : [];

      const items_count = uploadResponse.length;
      for (let index = 0; index < items_count; index++) {
        this.fileList.push({
          name: uploadResponse[index].Name,
          url: uploadResponse[index].Url
        });
      }

      const firstUploadedFile = this.fileList[0] || {};
      this.saves(firstUploadedFile.url || "");
    },
    handleError(/*err, file, fileList*/) {
      //console.log(err, file, fileList);
      this.isSaving = false;
    },
    saves(uploadedUrl) {
      let self = this;
      const currentUser = this.$store.state.user.user;
      const loggedUserId = currentUser.EmployeeId;

      const payload = {
        ...self.form,
        urlArchive: uploadedUrl || "",
        companyCode: currentUser.CompanySelected,
        employeeId: loggedUserId,
        createdBy: loggedUserId,
        IsPersonal: self.IsPersonal
      };

      self.$http
        .post("/api/Folder/CreateDocument", payload)
        .then(() => {
          self.$emit("dialog-closed");
          self.$message({
            type: "success",
            message: "Documento creado correctamente"
          });

          self.$emit("success");
          //window.location.reload();
        })
        .catch((err) => {
          self.$message({ type: "error", message: err.message });
          console.log("error");
        })
        .finally(() => {
          self.form = self.getEmptyForm();
          self.fileList = [];
          self.$refs.form_create.resetFields();
          self.isSaving = false;
        });
    },
    getEmptyForm() {
      return {
        nameArchive: "",
        descriptionArchive: "",
        urlArchive: "",
        companyCode: this.$store.state.user.user.CompanySelected,
        employeeId: this.$store.state.user.user.EmployeeId,
        createdBy: this.$store.state.user.user.EmployeeId
      };
    }
  },
  watch: {
    Visible(val) {
      this.form = this.getEmptyForm();
      if (!val) this.fileList = []; //this.$refs.uploadFile.uploadFiles = [];
    }
  }
};
</script>
<style scoped>
.title {
  /* Nuevo Documento */

  position: absolute;
  width: 143px;
  height: 19px;
  left: 20px;
  top: 52px;

  margin-left: 35%;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */

  color: #2484c4;
}

label .el-form-item__label {
  /* Adjuntar documento */

  width: 188px;
  height: 18px;

  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;

  color: #3c3c3c;
}

label {
  color: #bf3636;
  margin-top: 5px;
  margin-bottom: 5px;
}
ul > li > label > .el-upload-list--picture .el-upload-list__item-status-label {
  position: absolute;
  right: -17px;
  top: -7px;
  width: 46px;
  height: 26px;
  background: #5f8fdf;
  text-align: center;
  transform: rotate(45deg);
  box-shadow: 0 1px 1px #ccc;
}
</style>
